import { AxiosError } from "axios";

import { IqfAxiosError } from "iqf-web-ui/api-fetch";

export class AuthUnauthorizedError extends Error {
  constructor(message = "Unauthorized") {
    super(message);
    this.name = "AuthUnauthorizedError";
  }
}

export class AuthFlowRestartRequiredError extends Error {
  constructor() {
    super("OAuth login flow must be restarted.");
    this.name = "AuthFlowRestartRequiredError";
  }
}

export function isAuthFlowRestartRequiredError(error: unknown) {
  return error instanceof AuthFlowRestartRequiredError;
}

export class AuthLoginRecoveryFailedError extends Error {
  constructor() {
    super("OAuth login could not be completed.");
    this.name = "AuthLoginRecoveryFailedError";
  }
}

export function isUnauthorizedError(error: unknown) {
  if (error instanceof AuthUnauthorizedError) {
    return true;
  }

  if (error instanceof IqfAxiosError) {
    return error.status === 401;
  }

  if (error instanceof AxiosError) {
    return error.response?.status === 401;
  }

  if (typeof error !== "object" || error === null) {
    return false;
  }

  if ("status" in error && error.status === 401) {
    return true;
  }

  if (
    "response" in error &&
    typeof error.response === "object" &&
    error.response !== null &&
    "status" in error.response
  ) {
    return error.response.status === 401;
  }

  return false;
}
